module.exports = {
  defaultLocale: 'en',
  locales: ['en', 'jp'],
  prerender: true,
};
